<script>
import { h, provide, ref } from 'vue'
import sharePosterTemplate from '../components/share-poster-template.vue'
import templateGroup from '../components/template-group.vue'
import { ElTabs, ElTabPane } from 'element-plus'
import type from '@/common/utils/type'
export default {
  setup () {
    const sharePosterTemplateCom = ref(null)
    const tabs = {
      activeName: 'goodsSharePosterTemplate',
      tabs: [
        { label: '商品海报模板', name: 'goodsSharePosterTemplate', component: sharePosterTemplate, ref: sharePosterTemplateCom },
        { label: '模板类型', name: 'templateGroup', component: templateGroup }
      ]
    }
    provide('reloadTemplate', () => sharePosterTemplateCom.value.searchData())

    return {
      tabs
    }
  },
  render () {
    return h(
      ElTabs, {
        modelValue: this.tabs.activeName
      }, () => this.tabs.tabs.map(item => {
        return h(ElTabPane, {
          name: item.name,
          label: item.label
        }, () => [
          h(item.component, {
            ref: item.ref || '',
            type: type().templateGroupType.goodsSharePoster
          })
        ])
      })
    )
  }
}
</script>
<style lang="scss" scoped>
</style>
